import {
    DISCORD,
    FACEBOOK,
    GITHUB,
    INSTAGRAM,
    MEDIUM,
    TELEGRAM,
    TWITTER,
    WEBSITE,
} from './metaData.js';

// Official URLs
export const PROJECT_SUBMISSION_FORM_URL = 'https://docs.google.com/forms/d/1BYAfDoOxF3aLQydHj6yZEttQID5tgTHA_2Z5j-I0bd4';
export const WAGMI33_TWITTER_URL = 'https://twitter.com/wagmi33fund';
export const WAGMI33_URL = 'https://www.wagmi33.org/';
export const WAGMI33_CONTACT_EMAIL = 'contact@wagmi33.org';

// API endpoint
export const COINGECKO_API = 'https://api.coingecko.com/api/v3';

// Icon URL
export const ICONS = {
    [DISCORD]: 'https://cdn-icons-png.flaticon.com/128/356/356111.png',
    [FACEBOOK]: 'https://cdn-icons-png.flaticon.com/128/4406/4406234.png',
    [GITHUB]: 'https://cdn-icons-png.flaticon.com/128/1322/1322104.png',
    [INSTAGRAM]: 'https://cdn-icons-png.flaticon.com/512/1362/1362857.png',
    [MEDIUM]: 'https://cdn-icons-png.flaticon.com/128/725/725376.png',
    [TELEGRAM]: 'https://cdn-icons-png.flaticon.com/512/408/408839.png',
    [TWITTER]: 'https://cdn-icons-png.flaticon.com/128/356/356076.png',
    [`${TWITTER}_HOME`]: 'https://cdn-icons-png.flaticon.com/512/2111/2111819.png',
    [WEBSITE]: 'https://cdn-icons-png.flaticon.com/512/1225/1225834.png',
};
